import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ThfModalPasswordRecovery } from './interfaces/thf-modal-password-recovery.interface';

@Injectable()
export class ThfModalPasswordRecoveryService {

  constructor(private http: HttpClient) { }

  post(
    urlRecovery: string,
    item: ThfModalPasswordRecovery,
    params?: HttpParams | { [param: string]: string | Array<string>; }
    ): Observable<HttpResponse<Object>> {
    return this.http.post<any>(urlRecovery, item, { observe: 'response', params: params });
  }

}
